import { ModelSagres } from "@/types/model-sagres";

export class Emenda extends ModelSagres {
    IdEmenda: number
    IdTipoEmenda: number | null
    IdAutor: number | null
    NrEmenda: string
    NrAnoEmenda: number | null
    DtEmenda: Date | null
    VlEmenda: string
    CdBanco: string | null
    NrAgenciaBancaria: string
    NrContaBancaria: string
    FlPagamentoEspecial: boolean
    ArquivoExtratoForm: File
    ArquivoPlanoTrabalhoForm: File
    PathArquivoExtrato: string
    PathArquivoPlanoTrabalho: string
    FlAtivo: boolean

    constructor(obj?: any) {
        super();
        if (obj) {
            if (obj.IdEmenda) this.IdEmenda = obj.IdEmenda
            if (obj.IdTipoEmenda) this.IdTipoEmenda = obj.IdTipoEmenda
            if (obj.IdAutor) this.IdAutor = obj.IdAutor
            if (obj.NrEmenda) this.NrEmenda = obj.NrEmenda
            if (obj.NrAnoEmenda) this.NrAnoEmenda = obj.NrAnoEmenda
            if (obj.DtEmenda) this.DtEmenda = new Date(obj.DtEmenda)
            if (obj.VlEmenda) this.VlEmenda = obj.VlEmenda
            if (obj.CdBanco) this.CdBanco = obj.CdBanco
            if (obj.NrAgenciaBancaria) this.NrAgenciaBancaria = obj.NrAgenciaBancaria
            if (obj.NrContaBancaria) this.NrContaBancaria = obj.NrContaBancaria
            if (obj.FlPagamentoEspecial) this.FlPagamentoEspecial = obj.FlPagamentoEspecial
            if (obj.ArquivoExtratoForm) this.ArquivoExtratoForm = obj.ArquivoExtratoForm
            if (obj.ArquivoPlanoTrabalhoForm) this.ArquivoPlanoTrabalhoForm = obj.ArquivoPlanoTrabalhoForm
            if (obj.PathArquivoExtrato) this.PathArquivoExtrato = obj.PathArquivoExtrato
            if (obj.PathArquivoPlanoTrabalho) this.PathArquivoPlanoTrabalho = obj.PathArquivoPlanoTrabalho
            if (obj.FlAtivo !== undefined) this.FlAtivo = obj.FlAtivo
        }
    }
}
